module.exports = __webpack_public_path__ + "static/media/th.cc25f759.svg";